module.exports = "<p>\n  init works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/init/init.component.html
// module id = ./src/app/init/init.component.html
// module chunks = main